module.exports = __webpack_public_path__ + "img/Ines-Franken.fb87fd06.webp";